import { gql } from '@apollo/client'

const CREATE_TOKEN = gql`
  mutation createOneTimeToken($deliveryWorkDate: Datetime, $transporterId: UUID!) {
    createOneTimeToken(
      input: {
        oneTimeToken: { deliveryWorkDate: $deliveryWorkDate, transporterId: $transporterId }
      }
    ) {
      oneTimeToken {
        token
      }
    }
  }
`

export default {
  CREATE_TOKEN,
}